
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_m6mr2_97",
  "disabled": "awsui_disabled_1p2cx_m6mr2_137",
  "parent": "awsui_parent_1p2cx_m6mr2_140",
  "highlighted": "awsui_highlighted_1p2cx_m6mr2_143",
  "content": "awsui_content_1p2cx_m6mr2_147",
  "label-content": "awsui_label-content_1p2cx_m6mr2_154",
  "label": "awsui_label_1p2cx_m6mr2_154",
  "tag": "awsui_tag_1p2cx_m6mr2_161",
  "label-tag": "awsui_label-tag_1p2cx_m6mr2_162",
  "label-prefix": "awsui_label-prefix_1p2cx_m6mr2_172",
  "tags": "awsui_tags_1p2cx_m6mr2_185",
  "description": "awsui_description_1p2cx_m6mr2_186",
  "selected": "awsui_selected_1p2cx_m6mr2_197",
  "icon": "awsui_icon_1p2cx_m6mr2_211",
  "icon-size-big": "awsui_icon-size-big_1p2cx_m6mr2_218",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_m6mr2_222",
  "trigger-variant": "awsui_trigger-variant_1p2cx_m6mr2_237"
};
  